import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../../components/ui/Card';
import { Textarea } from '../../components/ui/Input';
export function WordCounter() {
  const [text, setText] = useState('');
  const [stats, setStats] = useState({
    characters: 0,
    charactersNoSpaces: 0,
    words: 0,
    sentences: 0,
    paragraphs: 0,
    readingTime: 0
  });
  useEffect(() => {
    const characters = text.length;
    const charactersNoSpaces = text.replace(/\s/g, '').length;
    const words = text.trim() ? text.trim().split(/\s+/).length : 0;
    const sentences = text.split(/[.!?]+/).filter(s => s.trim().length > 0).length;
    const paragraphs = text.split(/\n\n+/).filter(p => p.trim().length > 0).length;
    const readingTime = Math.ceil(words / 200); // Average reading speed: 200 words/min
    setStats({
      characters,
      charactersNoSpaces,
      words,
      sentences,
      paragraphs,
      readingTime
    });
  }, [text]);
  return <div className="container mx-auto px-4 py-8 max-w-4xl" data-id="element-694">
      <div className="mb-8" data-id="element-695">
        <h1 className="text-4xl font-bold mb-2" data-id="element-696">Word & Character Counter</h1>
        <p className="text-muted-foreground" data-id="element-697">
          Count words, characters, sentences, and more
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-698">
        <div className="lg:col-span-2" data-id="element-699">
          <Card data-id="element-700">
            <CardHeader data-id="element-701">
              <CardTitle data-id="element-702">Enter Your Text</CardTitle>
              <CardDescription data-id="element-703">Type or paste your text below</CardDescription>
            </CardHeader>
            <CardContent data-id="element-704">
              <Textarea value={text} onChange={e => setText(e.target.value)} placeholder="Start typing or paste your text here..." rows={15} className="font-mono" data-id="element-705" />
            </CardContent>
          </Card>
        </div>

        <div className="space-y-4" data-id="element-706">
          <Card data-id="element-707">
            <CardContent className="pt-6" data-id="element-708">
              <div className="space-y-4" data-id="element-709">
                <div className="text-center p-4 bg-primary/10 rounded-lg" data-id="element-710">
                  <p className="text-sm text-muted-foreground mb-1" data-id="element-711">Words</p>
                  <p className="text-3xl font-bold text-primary" data-id="element-712">
                    {stats.words}
                  </p>
                </div>
                <div className="text-center p-4 bg-muted rounded-lg" data-id="element-713">
                  <p className="text-sm text-muted-foreground mb-1" data-id="element-714">
                    Characters
                  </p>
                  <p className="text-2xl font-semibold" data-id="element-715">{stats.characters}</p>
                </div>
                <div className="text-center p-4 bg-muted rounded-lg" data-id="element-716">
                  <p className="text-sm text-muted-foreground mb-1" data-id="element-717">
                    Characters (no spaces)
                  </p>
                  <p className="text-2xl font-semibold" data-id="element-718">
                    {stats.charactersNoSpaces}
                  </p>
                </div>
                <div className="text-center p-4 bg-muted rounded-lg" data-id="element-719">
                  <p className="text-sm text-muted-foreground mb-1" data-id="element-720">
                    Sentences
                  </p>
                  <p className="text-2xl font-semibold" data-id="element-721">{stats.sentences}</p>
                </div>
                <div className="text-center p-4 bg-muted rounded-lg" data-id="element-722">
                  <p className="text-sm text-muted-foreground mb-1" data-id="element-723">
                    Paragraphs
                  </p>
                  <p className="text-2xl font-semibold" data-id="element-724">{stats.paragraphs}</p>
                </div>
                <div className="text-center p-4 bg-muted rounded-lg" data-id="element-725">
                  <p className="text-sm text-muted-foreground mb-1" data-id="element-726">
                    Reading Time
                  </p>
                  <p className="text-2xl font-semibold" data-id="element-727">
                    {stats.readingTime} min
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>;
}